module.exports = __webpack_public_path__ + "static/media/bahrain.3a8dfb0a.png";